// TODO: IS-262 ws/WebSocketの表記を統一する
import type { WebSocketClientOptions } from './types';
import { WebSocketClient } from './WebSocketClientClass';

type WsClientType = 'agent' | 'inputSupport';

const CLIENT_CONFIG: Record<
  WsClientType,
  Omit<WebSocketClientOptions, 'authOrigin' | 'unauthorizedRedirectUrl'>
> = {
  agent: {
    url: process.env.AGENT_CHAT_WS_URL || '',
    connectTimeout: 10_000,
  },
  inputSupport: {
    url: process.env.INPUT_SUPPORT_WS_URL || '',
    connectTimeout: 5_000,
    messageTimeout: 10_000,
  },
};

const SHARED_CONFIG = {
  authOrigin: process.env.AUTH_ORIGIN_SERVER_URL,
  unauthorizedRedirectUrl: process.env.UNAUTHORIZED_REDIRECT_URL || '/unauthorized',
};

const instances = new Map<WsClientType, WebSocketClient>();

export function getWsClient(type: WsClientType): WebSocketClient {
  if (!instances.has(type)) {
    instances.set(type, new WebSocketClient({ ...SHARED_CONFIG, ...CLIENT_CONFIG[type] }));
  }
  return instances.get(type)!;
}

export const agentWsClient = getWsClient('agent');
export const inputSupportWsClient = getWsClient('inputSupport');
